import Vue from "vue"
import Vuex from "vuex"
import user from "./modules/user"
import location from "./modules/location"
import cart from "./modules/cart"
import receiving from "./modules/receiving"
import getters from "./getters"
import msg from "./modules/message"

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    user,
    location,
    cart,
    receiving,
    msg,
  },
  getters,
})

export default store
